import _language from "./Language/Language";
import _validators from "./Validators/Validators";
import _hotelSearch from "./HotelSearch/HotelSearch";
import _transferUtils from "./Utils/Transfer";
import _userMessage from "./UserMessage/UserMessage";
import _infoHotelUtils from "./Utils/InfoHotel";
import _eventPopup from "./Utils/EventPopup";

const Language = _language;
const Validators = _validators;
const HotelSearch = _hotelSearch;
const TransferUtils = _transferUtils;
const UserMessage = _userMessage;
const InfoHotelUtils = _infoHotelUtils;
const EventPopup = _eventPopup;

export {
  Language,
  Validators,
  HotelSearch,
  TransferUtils,
  UserMessage,
  InfoHotelUtils,
  EventPopup
};
